import { Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import CustomInput from '../../../components/common/CustomInput'
import CustomSelect from '../../../components/common/CustomSelect'
import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().trim().required('State is required'),
  country: Yup.string().trim().required('Country is required'),
})

function Edit() {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [countryOptions, setCountryOptions] = useState([])

  const fetchCountryData = async () => {
    try {
      const response = await axiosAuthInstance.get('country/dropdown')
      if (response.status === 200) {
        const transformedData = response?.data?.result?.map((item) => ({
          value: item._id,
          label: item.name,
        }))
        setCountryOptions(transformedData)
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    fetchCountryData()
  }, [])

  const formik = useFormik({
    onSubmit: (values, formikHelpers) => handleSubmit(values, formikHelpers),
    validationSchema,
    initialValues: {
      name: '',
      country: '',
    },
  })

  const fetchData = async () => {
    try {
      const response = await axiosAuthInstance.get(`state/detail/${id}`)
      formik.setValues({
        name: response.data.result.name,
        country: response.data.result.country._id,
      })
      setLoading(false)
    } catch (error) {
      console.log('error in fetching edit data: ', error)
    }
  }
  useEffect(() => {
    fetchData()
  }, [id])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const response = await axiosAuthInstance.put(`state/update/${id}`, {
        name: values.name,
        country: values.country,
      })
      if (response) {
        navigate('/state')
      }
    } catch (error) {
      console.log(error)
    }
  }

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <FormikProvider value={formik}>
      <form
        className='flex flex-col p-4 gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          formik.handleSubmit()
        }}
      >
        <Field
          name='name'
          label='State'
          placeholder='Enter State'
          required
          component={CustomInput}
        />
        <Field
          name='country'
          label='Country'
          placeholder='Country'
          required
          component={CustomSelect}
          options={countryOptions}
        />
        <button
          type='submit'
          disabled={formik.isSubmitting}
          className='bg-primary text-xl font-medium text-white rounded-lg px-6 py-2'
        >
          Update
        </button>
      </form>
    </FormikProvider>
  )
}

export default Edit
